const getObjectLength = <T>(object: T[]): number => object?.length ?? 0;

export { getObjectLength };
